import {
  getAccessPolicy,
  GetAccessPolicyData,
  GetAccessPolicyResponse,
} from '@data-access/connect/tc-ecom';
import type { Client } from '@data-access/connect/tc-issue-management';
import type { Client as EcomClient } from '@hey-api/client-fetch';
import { useQuery, UseQueryResult, QueryClient } from '@tanstack/solid-query';
import { Accessor } from 'solid-js';

export class EcomApiService {
  constructor(
    private readonly client: Client,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore TS6138: Reserved for future use
    private readonly queryClient: QueryClient
  ) {}

  // Query for getting access policy
  public getAccessPolicyQuery(
    options?: Accessor<Omit<GetAccessPolicyData, 'client'> | undefined>
  ): UseQueryResult<GetAccessPolicyResponse, Error> {
    return useQuery(() => ({
      queryKey: ['access-policy', options?.()],
      queryFn: async (): Promise<GetAccessPolicyResponse> => {
        const response = await getAccessPolicy({
          client: this.client as unknown as EcomClient,
          ...options?.(),
        });

        if (response.error) {
          throw new Error('Failed to get access policy');
        }

        return response.data;
      },
      enabled: true,
    }));
  }
}
